import { z } from 'zod';

/** Admin — 平移上级（整条主号线 + 子账户 + 推荐网体迁移） */
export const AdminShiftUplineSchema = z.object({
  /** 新上级用户名或编号（如 uo23456 / 106060） */
  new_upline_username: z.string().min(1).max(32),
  /** 安置起点（默认新上级本人）；须在新上级网体下 */
  placement_user_id: z.number().int().positive().optional(),
  /** 左/右区安置（含滑落） */
  position: z.enum(['L', 'R']),
  note: z.string().min(3).max(500),
  xian: z.boolean(),
});

export type AdminShiftUplineRequest = z.infer<typeof AdminShiftUplineSchema>;
